export type ListPageType =
  | 'users'
  | 'organizations'
  | 'patients'
  | 'roles'
  | 'wounds'
  | 'appointments';

export type ColType =
  | 'user'
  | 'name'
  | 'data'
  | 'dataOrg'
  | 'dataEmail'
  | 'actions'
  | 'organizations';

export interface ListColumnConfig {
  key: string;
  labelKey: string;
  colType: ColType;
  mobileLabel?: string;
}

export interface ListPageConfig {
  pageTitleKey: string;
  columns: ListColumnConfig[];
}

export const LIST_PAGE_CONFIG: Partial<Record<ListPageType, ListPageConfig>> = {
  appointments: {
    pageTitleKey: 'appoinmentList',
    columns: [
      {
        key: 'Patient',
        labelKey: 'patientNameSurname',
        colType: 'user',
        mobileLabel: 'Patient',
      },
      {
        key: 'PatientID',
        labelKey: 'pid',
        colType: 'data',
        mobileLabel: 'PID',
      },
      {
        key: 'CreatedDate',
        labelKey: 'date',
        colType: 'data',
        mobileLabel: 'Date',
      },
      {
        key: 'Role',
        labelKey: 'createdBy',
        colType: 'data',
        mobileLabel: 'Created By',
      },
      {
        key: 'Status',
        labelKey: 'status',
        colType: 'data',
        mobileLabel: 'Status',
      },
    ],
  },
};
